module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f4a5.d198f92b.svg";